import React from "react"
import { Switch, Route } from "react-router"
import { motion, AnimatePresence } from "framer-motion"
import Div100vh from "react-div-100vh"
import Makers from "./Makers"
import Visionaries from "./Visionaries"
import Scheme from "./Scheme"
import Future from "./Future"
import { AboutPath } from "../../routes"
import "./AboutUs.css"

const AboutCard = ({ data }) => {
  return (
    <div
      className="about-card"
      onClick={() => {
        window.location = `${AboutPath}/${data.mainTitle.toLowerCase()}`
      }}
    >
      <div className="title-wraper">
        <div className="main-title">{data.mainTitle}</div>
        <div className="sub-title">{data.subTitle}</div>
      </div>
      <div className="background-wraper">
        <div
          className="fog-box"
          style={{ backgroundColor: data.fogColor }}
        ></div>
        <img className="about-tile-image" alt="" src={data.image} />
      </div>
    </div>
  )
}

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.8
}

const MainAboutUs = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Div100vh className="about-container">
        {fetchData.map((data, index) => (
          <AboutCard key={index} data={data} />
        ))}
      </Div100vh>
    </motion.div>
  )
}

const fetchData = [
  {
    mainTitle: "Taylor Wimpey",
    subTitle: "THE MAKERS",
    fogColor: "rgba(100, 72, 129, 0.8)",
    image: "/assets/images/about/img-1c.jpg",
    component: Makers
  },
  {
    mainTitle: "The Architects",
    subTitle: "VISIONARIES",
    fogColor: "rgba(189, 178, 181, 0.5)",
    image: "/assets/images/about/img-1d.jpg",
    component: Visionaries
  },
  {
    mainTitle: "Coronation Sq",
    subTitle: "THE DEVELOPMENT",
    fogColor: "rgba(100, 72, 129, 0.6)",
    image: "/assets/images/about/img-1b.jpg",
    component: Scheme
  },
  {
    mainTitle: "Enquiries",
    subTitle: "YOUR FUTURE HOME",
    fogColor: "rgba(189, 178, 181, 0.6)",
    image: "/assets/images/about/img-1a.jpg",
    component: Future
  }
]

function AboutUs({ match: { url } }) {
  return (
    <AnimatePresence>
      <Switch>
        <Route exact path={url} component={MainAboutUs} />
        {fetchData.map(({ mainTitle, component: Component }, index) => (
          <Route
            key={index}
            path={`${url}/${mainTitle}`}
            component={Component}
          />
        ))}
      </Switch>
    </AnimatePresence>
  )
}

export default AboutUs
